import React from 'react';
import './style.scss';

const Button = ({children,...otherProps}) => {
    return (
        <button {...otherProps} className="custom__button">
            {children}
        </button>
    )
}


export default Button
